import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { useSetPageContext } from "@/features/shared/page-context";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  accountId: z.string().optional(),
  ...maskSearchFragment,
});

function AccountsPlaceholder() {
  useSetPageContext({ view: { screen: "accounts_list" } });
  return (
    <div className="p-6 text-text-dark-high">
      Accounts section — coming soon. Route ready for migration.
    </div>
  );
}

export const Route = createFileRoute("/admin/accounts/")({
  validateSearch: searchSchema,
  component: AccountsPlaceholder,
});
